// extracted by mini-css-extract-plugin
export default {"Container":"TeamBadge_Container__3SHqU"};